namespace RioERP.Carts {
    export interface CounterCartForm {
        CustomerId: Serenity.LookupEditor;
        CustomerName: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        CustomerEmail2: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerMobile2: Serenity.StringEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingPincode: Serenity.IntegerEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.LookupEditor;
        ShippingPincode: Serenity.IntegerEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        DiscountCoupon: Serenity.StringEditor;
        DiscountAmount: Serenity.DecimalEditor;
        SourceOrderNumber: Serenity.StringEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.EnumEditor;
        EPaymentType: Serenity.EnumEditor;
        CartProducts: CartProductsEditor;
    }

    export class CounterCartForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.CounterCart';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CounterCartForm.init)  {
                CounterCartForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.EnumEditor;
                var w5 = CartProductsEditor;

                Q.initFormType(CounterCartForm, [
                    'CustomerId', w0,
                    'CustomerName', w1,
                    'CustomerEmail1', w1,
                    'CustomerEmail2', w1,
                    'CustomerMobile1', w1,
                    'CustomerMobile2', w1,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w0,
                    'BillingPincode', w2,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingStateId', w0,
                    'ShippingPincode', w2,
                    'InvoiceCompanyId', w0,
                    'DiscountCoupon', w1,
                    'DiscountAmount', w3,
                    'SourceOrderNumber', w1,
                    'GrossAmount', w3,
                    'NetAmount', w3,
                    'TaxableAmount', w3,
                    'TaxAmount', w3,
                    'EPaymentStatus', w4,
                    'EPaymentType', w4,
                    'CartProducts', w5
                ]);
            }
        }
    }
}
